import styles from './snapshotDivider.module.scss';

export function SnapshotDivider(): React.JSX.Element {
    return (
        <div className={styles.divider}>
            <div className={styles.dividerLine} />
        </div>
    );
}
